import {useMutation} from "@tanstack/react-query";

import {residentClaimService} from "../services";
import type {StartClaimRequest} from "../types";

export default function useResidentClaimStart() {
  return useMutation({
    mutationFn: (body: StartClaimRequest) => residentClaimService.startClaim(body),
  });
}
